import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Contact } from '../../../admin/models/contact.model';
import { DynamicDialogService } from "../../../core/services/dynamic-dialog.service";


@Component({
    selector: 'org-contact-editor-modal',
    templateUrl: './org-contact-editor-modal.component.html',
    styleUrls: ['./org-contact-editor-modal.component.scss'],
    standalone: false
})
export class OrgContactEditorModalComponent implements OnInit {


	get disableSave(): boolean {
		if (this.form == null) return true;
		return this.form.pristine;
	}

	form: FormGroup = new FormGroup({});

	selectedContact: Contact;

	get contactName(): string {
		if (this.selectedContact == null) return "";
		let name: string = this.selectedContact.fullLegalName;
		if (name == null) {
			name = `${this.selectedContact.firstName} ${this.selectedContact.lastName}`;
		}
		return name;
	}

	@Output() contactUpdated: EventEmitter<Contact> = new EventEmitter<Contact>();

	showModal: boolean = false;

	constructor(private builder: FormBuilder, private dialog: DynamicDialogService) { }

	ngOnInit() {
		this.form = this.buildForm();
	}

	buildForm(): FormGroup {
		const phonePattern = '^\\s*$|^(\\+1\\s*)?(\\d{10}|\\(?\\d{3}\\)?[-.\\s]?\\d{3}[-.\\s]?\\d{4})$';
		return this.builder.group({
			primaryPhone: [{ value: "", disabled: false }, [Validators.pattern(phonePattern)]],
			secondaryPhone: [{ value: "", disabled: false }, [Validators.pattern(phonePattern)]],
			email: [{ value: "", disabled: false }, [Validators.email]]
		})

	}

	close(): void {
		this.showModal = false;
		this.form = this.buildForm();
	}

	fillForm(contact: Contact): void {
		this.form.get('primaryPhone').setValue(contact.primaryPhone);
		this.form.get('secondaryPhone').setValue(contact.secondaryPhone);
		this.form.get('email').setValue(contact.emailAddress);
	}

	openForm(data: Contact): void {
		this.selectedContact = data;
		this.fillForm(this.selectedContact);
		this.showModal = true;
	}

	save(): void {
		this.form.updateValueAndValidity();
		if (this.form.invalid) {
			this.dialog.showFormInvalid();
		} else {
			this.selectedContact.primaryPhone = this.form.get('primaryPhone').value;
			this.selectedContact.secondaryPhone = this.form.get('secondaryPhone').value;
			this.selectedContact.emailAddress = this.form.get('email').value;
			this.contactUpdated.emit(this.selectedContact);
			this.close();
		}
	}
}
